import { HeartHandshake, GraduationCap, HandHeart, BookOpen } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const PHOTO =
  "https://images.unsplash.com/photo-1624272864537-8ecc72b67958?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxhdXRpc20lMjBjYXJlJTIwcGFyZW50JTIwY2hpbGQlMjBoYXBweSUyMHdhcm18ZW58MHx8fHwxNzkwNzc2ODAwfDA&ixlib=rb-4.1.0&q=85";

const items = [
  {
    icon: HeartHandshake,
    tint: "bg-rose-100 text-rose-700",
    title: "Pais e familiares",
    desc: "Para compreender melhor as necessidades e as situações do cotidiano.",
  },
  {
    icon: GraduationCap,
    tint: "bg-brandlight text-brand",
    title: "Professores e educadores",
    desc: "Para apoiar práticas mais acessíveis e inclusivas em sala de aula.",
  },
  {
    icon: HandHeart,
    tint: "bg-green-100 text-green-700",
    title: "Cuidadores",
    desc: "Para organizar estratégias de cuidado e apoio com segurança.",
  },
  {
    icon: BookOpen,
    tint: "bg-amber-100 text-amber-700",
    title: "Quem está começando",
    desc: "Para dar os primeiros passos no entendimento sobre o TEA.",
  },
];

export default function Audience() {
  return (
    <section id="para-quem" className="bg-sandalt/60">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 py-24 md:grid-cols-2 md:px-12 md:py-32">
        <Reveal className="relative">
          <div className="absolute -left-5 -top-5 h-28 w-28 rounded-full bg-aqua/30 blur-lg" />
          <img
            data-testid="audience-photo"
            src={PHOTO}
            alt="Pai abraçando a filha sorrindo"
            loading="lazy"
            className="relative w-full rounded-[2rem] object-cover shadow-[0_32px_64px_-24px_rgba(10,25,47,0.35)]"
            style={{ aspectRatio: "4/4.6" }}
          />
          <div className="absolute -bottom-6 -right-4 max-w-[240px] rounded-2xl bg-white p-5 shadow-[0_20px_48px_-16px_rgba(10,25,47,0.3)] md:-right-8">
            <p className="font-display text-base italic leading-snug text-navy">
              “Compreender, acolher e cuidar faz toda a diferença.”
            </p>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <p className="mb-4 text-xs font-extrabold uppercase tracking-[0.22em] text-flame">
              Para quem é
            </p>
            <h2 className="mb-5 font-display text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">
              Um material para quem quer cuidar melhor.
            </h2>
            <p className="mb-10 max-w-lg text-base leading-relaxed text-ink sm:text-lg">
              Um guia de consulta para quem deseja aprender mais e oferecer um apoio
              mais consciente — em casa, na escola e na comunidade.
            </p>
          </Reveal>
          <div className="space-y-4">
            {items.map((it, i) => (
              <Reveal key={it.title} delay={0.08 * i}>
                <div
                  data-testid={`audience-item-${i}`}
                  className="flex items-start gap-4 rounded-2xl border border-[#E2E8F0] bg-white p-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_36px_-16px_rgba(10,25,47,0.25)]"
                >
                  <span className={`grid h-11 w-11 shrink-0 place-items-center rounded-xl ${it.tint}`}>
                    <it.icon className="h-5 w-5" strokeWidth={2.2} />
                  </span>
                  <div>
                    <h3 className="font-display text-lg font-semibold text-navy">{it.title}</h3>
                    <p className="text-sm leading-relaxed text-ink">{it.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
